module.exports = __webpack_public_path__ + "img/footer-link-01.41ecc393.png";